import { useFormik } from 'formik';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { toaster } from 'src/utils/toaster';
import { createTaskProgressNotes, taskProgressNotesUpdate } from 'src/services/TaskProgressNote';
import ResponsiveTextWithIconButton from 'src/components/Responsive/ResponsiveTextWithIconButton';
import rightIcon from 'src/assets/svgs/rightIcon.svg';
import IconWithButton from 'src/components/Common/IconWithButton';
import { dateTimeFormate, getRemovetzTime, tokenDecode, utcConverter } from 'src/utils/function';
import calenderIcon from 'src/assets/svgs/calenderIcon.svg';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import closeIcon from 'src/assets/img/closeImg.png';
import AsyncSelect from 'react-select/async';
import westImg from 'src/assets/img/westImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import { employeeList } from 'src/services/employee';

const AddNewTaskProgressNote = ({ setIsSave, isSave, isOnSuccess, setBtnDisabled, btnDisabled, isUpdate, selectedRowData, selectedTaskId }: any) => {
    const [error, setError] = useState('');

    const [isSaveValidation, setIsSaveValidation] = useState(false);
    const [calenderOpen, setCalenderOpen] = useState({ start: false, end: false, payment: false });
    const [date, setDate] = useState<Date | null>(null);
    const foramteNewDate = (isDate: any) => new Date(getRemovetzTime(isDate, 'YYYY-MM-DD HH:mm:ss'));
    const [selectedEmployeeOption, setSelectedEmployeeOption] = useState<any>([]);
    const [employeeListData, setEmployeeListData] = useState<any>([]);
    // const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

    const [userData, setUserData] = useState<any>({});
    const getToken = async () => {
        const token = await tokenDecode();
        setUserData(token);
    };
    useEffect(() => {
        getToken();
    }, []);

    useEffect(() => {
        if (isSave) {
            formik.handleSubmit();
            setIsSave(false);
            setIsSaveValidation(true);
        }
    }, [isSave]);

    const handleEmployeeSelect = (selectedOption: any) => {
        const selected = Array.isArray(selectedOption) ? selectedOption : [];
        const selectedEmployeeIds = selected.map((opt: any) => opt.value);

        formik.setFieldValue('employeeId', selectedEmployeeIds);
        setError('');
        setSelectedEmployeeOption(selected);

        // const employees = selectedOption?.employeesData || [];
        // const employee = employees.find((emp: any) => emp.employeeId === selectedEmployeeIds[0]);
        // setSelectedEmployee(employee || null);
    };
    const getEmployList = useCallback(async (inputValue: string) => {
        try {
            let empIds = selectedTaskId.emp ? `&emp=${selectedTaskId.emp}` : '';
            const url = `?page=0&limit=20${empIds}&search=${inputValue}`;
            const res = await employeeList(url);
            const employees = res?.data?.data?.employees || [];
            setEmployeeListData(employees);
            const options = [
                {
                    label: (
                        <div className="flex gap-6 font-semibold text-gray-600 text-sm border-b pb-1">
                            <span className="min-w-20">Company</span>
                            <span>Job Type</span>
                            <span>Employee Name</span>
                        </div>
                    ),
                    value: '__header__',
                    isDisabled: true,
                },
                ...employees.map((emp: any) => ({
                    label: (
                        <div className="flex gap-6">
                            <div className="flex gap-2 min-w-20">
                                <img
                                    src={emp.companyName === 'West' ? westImg : emp.companyName === 'Log' ? logImg : emp.companyName === 'Liani' ? lianiImg : fsImg}
                                    className="w-5 h-5"
                                    alt={emp.companyName}
                                />
                                <span>{emp.companyName}</span>
                            </div>
                            <span>{emp.jobType}</span>
                            <span>
                                {emp.name} {emp.surname}
                            </span>
                        </div>
                    ),
                    value: emp.employeeId,
                    employeesData: employees,
                })),
            ];
            return options;
        } catch (err) {
            return [];
        }
    }, []);

    const makeTimeFormate = (formateTime: any, formateDate: any) => {
        const formattedTime = moment(formateTime, 'HH:mm').format('hh:mma');
        const newDate = moment(formateDate, 'ddd MMM DD YYYY HH:mm:ss ZZ').format('YYYY-MM-DD');
        const originalDateTime = `${newDate} ${formattedTime}`;
        const formattedDate = moment(originalDateTime, 'YYYY-MM-DD hh:mma').format('YYYY-MM-DD HH:mm:ss');
        return formattedDate;
    };
    const handleDateChange = useCallback(
        (dateValue: Date, type: 'start' | 'end') => {
            if (type === 'start') {
                setDate(dateValue);

                const finalDate = makeTimeFormate('00:00', dateValue);
                formik.setFieldValue('date', finalDate);
            }
        },
        [date],
    );
    const parseEmployeeIds = (ids: any) => {
        if (Array.isArray(ids)) return ids;
        if (!ids) return [];

        if (typeof ids === 'string') {
            try {
                const parsed = JSON.parse(ids);
                if (Array.isArray(parsed)) return parsed;
            } catch {
                // fallback comma-separated format
                return ids
                    .replace(/\[|\]|\s+/g, '')
                    .split(',')
                    .filter(Boolean);
            }
        }

        return [];
    };

    const getInitialValues = useCallback(() => {
        if (isUpdate && selectedRowData) {
            return {
                note: selectedRowData.note || null,
                date: selectedRowData.date,
                taskId: selectedRowData.taskId,
                employeeId: parseEmployeeIds(selectedRowData.empIds),
            };
        }

        return {
            note: null,
            date: '',
            taskId: selectedTaskId?.id,
            employeeId: [],
        };
    }, [isUpdate, selectedRowData]);
    const CustomStartInput = forwardRef<HTMLDivElement>((props, ref) => (
        <div ref={ref} className="sidebar_date">
            <IconWithButton
                isMoreClass={`!w-full !justify-start`}
                title={date ? dateTimeFormate(date, 'DD MMM, YYYY') : 'Date'}
                icon={calenderIcon}
                onclick={() => setCalenderOpen((prev) => ({ ...prev, start: true }))}
            />
        </div>
    ));

    const onSubmit = async (values: any, helpers: any) => {
        setBtnDisabled(true);
        let payload = {
            note: values.note ?? null,
            date: utcConverter(values.date, 'YYYY-MM-DD HH:mm:ss'),
            taskId: selectedTaskId?.id,
            empIds: values.employeeId || [],
            userId: userData?.id,
        };
        try {
            if (isUpdate) {
                const updatePayload = { ...payload, progressNoteId: selectedRowData.id };
                const res = await taskProgressNotesUpdate(updatePayload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            } else {
                const res = await createTaskProgressNotes(payload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            }
        } catch (err: any) {
            setError(err?.response.message);
            setBtnDisabled(false);
        }
    };

    const formik = useFormik({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: Yup.object({
            note: Yup.string().required('Please enter note'),
            date: Yup.string().required('Please select date'),
            employeeId: Yup.array().of(Yup.string()).min(0, 'Please select at least one employee'),
        }),
        onSubmit: onSubmit,
    });

    useEffect(() => {
        if (isUpdate && selectedRowData?.empIds) {
            const ids = parseEmployeeIds(selectedRowData.empIds);
            const empids = parseEmployeeIds(selectedRowData.empList);
            if (ids.length > 0) {
                const selectedOptions = empids.map((id: any) => {
                    const emp = employeeListData.find((item: any) => item.employeeId === id.id || item.employeeId === Number(id.id));
                    if (emp) {
                        return {
                            value: emp.employeeId,
                            label: `${emp.name} ${emp.surname}`,
                            employeesData: employeeListData,
                        };
                    }
                    return { value: id.id, label: `${id.name} ${id.surname}` };
                });
                setSelectedEmployeeOption(selectedOptions);
            }
            formik.setFieldValue('employeeId', ids);
        }
        if (isUpdate && selectedRowData.id) {
            setDate(selectedRowData.date ? foramteNewDate(selectedRowData.date) : null);
        }
    }, [isUpdate, selectedRowData?.empIds, employeeListData, selectedRowData?.id]);

    return (
        <>
            <div className="p-8 mt-6 bg-white rounded-3xl">
                <div>
                    <div>
                        <p className="text-black text-base font-black">Adding new Task Progress Note</p>
                        <p className="text-black text-sm font-medium leading-none mt-2">all the information bellow is required to add new Adding new task progress note</p>
                    </div>
                    <form className="mt-4 gap-5">
                        <div className="flex flex-row gap-5 max-lg:flex-col">
                            <div className="flex flex-col gap-3">
                                <div className="flex flex-col md:flex-row gap-5 max-lg:w-full">
                                    {/* <div className="md:w-1/2 lg:w-[230px] w-full">
                                        <Dropdown
                                            value={formik.values.taskId}
                                            options={taskListData}
                                            optionLabel="name"
                                            optionValue="value"
                                            placeholder="Select task"
                                            className="w-full border !h-[42px] !leading-[16px]"
                                            onChange={(e) => {
                                                formik.setFieldValue('taskId', e.value);
                                                setError('');
                                            }}
                                            onBlur={() => formik.setFieldTouched('taskId', true)}
                                        />
                                        {formik.touched.taskId && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.taskId as string}</p>}
                                    </div> */}
                                    <div className="w-full voucher-date-range-picker-responsive">
                                        <DatePicker
                                            selected={date}
                                            onChange={(dateValue: Date) => handleDateChange(dateValue, 'start')}
                                            open={calenderOpen.start}
                                            onClickOutside={() => setCalenderOpen((prev) => ({ ...prev, start: false }))}
                                            customInput={<CustomStartInput />}
                                            showPopperArrow={false}
                                            calendarClassName="sort-custom-datepicker bg-black text-gray-100 !w-full"
                                            className="w-full"
                                        >
                                            <div className="inline-flex job-filter-btn pb-2">
                                                <IconWithButton title={dateTimeFormate(date, 'DD MMM, YYYY')} />
                                                <button type="button" className="ms-5" onClick={() => setCalenderOpen((prev) => ({ ...prev, start: false }))}>
                                                    <img src={closeIcon} className="w-6 h-6 rounded-full me-2" alt="close" />
                                                </button>
                                            </div>
                                        </DatePicker>
                                        {formik.touched.date && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.date as string}</p>}
                                    </div>
                                </div>
                                <div className="flex flex-col md:flex-row gap-5 max-lg:w-full">
                                    <div className="md:w-1/2 lg:w-1/2 w-full"> </div>
                                </div>
                                <div className="w-full">
                                    <AsyncSelect
                                        isMulti
                                        cacheOptions
                                        value={selectedEmployeeOption}
                                        loadOptions={getEmployList}
                                        defaultOptions={true}
                                        placeholder="Search Employee"
                                        className="text-sm font-medium w-full lg:min-w-[340px]"
                                        isOptionDisabled={(option) => option.value === '__header__'}
                                        classNames={{
                                            control: (state) => `bg-gray-100 border rounded-lg ${state.isFocused ? 'border-blue-500' : 'border-gray-300'} focus:outline-none`,
                                            menu: () => 'bg-white shadow-lg rounded-lg mt-1',
                                            menuList: () => 'max-h-60 overflow-auto',
                                            option: (state) => `px-4 py-2 cursor-pointer text-gray-900 ${state.isFocused ? 'bg-blue-50' : ''} ${state.isSelected ? 'bg-blue-500 text-white' : ''}`,
                                            placeholder: () => 'text-gray-500',
                                            singleValue: () => 'text-gray-900',
                                        }}
                                        isClearable
                                        menuPlacement="bottom"
                                        loadingMessage={() => 'Fetching jobs...'}
                                        noOptionsMessage={() => 'No jobs found'}
                                        onChange={handleEmployeeSelect}
                                    />
                                </div>
                                <div className="w-full">
                                    <textarea
                                        value={formik.values.note ?? ''}
                                        onChange={(e: any) => {
                                            formik.handleChange(e);
                                            setError('');
                                            setIsSaveValidation(false);
                                        }}
                                        rows={4}
                                        name="note"
                                        cols={50}
                                        className="h-16 w-full px-4 py-3 bg-zinc-100 rounded-xl mt-2 text-sm font-normal scrollbar-default"
                                        placeholder="Note"
                                        style={{ resize: 'none', outline: 'none' }}
                                    />
                                    {formik.touched.note && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.note as string}</p>}
                                </div>
                            </div>
                        </div>

                        {error && <p className="text-red-600 mt-10 text-sm text-center">{error}</p>}
                    </form>
                </div>
            </div>
            <div className="hidden max-lg:block  pb-3 max-md:pt-5 max-lg:pt-[26px]">
                <ResponsiveTextWithIconButton title={'SAVE'} icon={rightIcon} isDisabled={btnDisabled} onclick={() => setIsSave(true)} />
            </div>
        </>
    );
};
export default AddNewTaskProgressNote;
